var categorySquareFeetPrice = document.getElementById(
  "category_squarefeet_price"
).value;
var custom_rug_id = 50816927301951; // Replace with your actual product ID for custom rugs

function toggleQuoteSection() {
  const quoteSection = document.querySelector(".quote-section");
  quoteSection.classList.toggle("hidden");
}

// Toggle custom size section
function toggleSection() {
  var section = document.querySelector(".section-size");
  var showMore = document.querySelector(".show-more");
  var showLess = document.querySelector(".show-less");
  var totalSection = document.querySelector(".total");

  section.classList.toggle("hidden");
  showMore.classList.toggle("hidden");
  showLess.classList.toggle("hidden");
  totalSection.classList.add("hidden");
}

function scrollToCustomForm() {
  const form = document.getElementById("custom-size-form");
  if (form) {
    form.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

// Reset form when inputs change
function resetForm() {
  document.querySelector(".total").classList.add("hidden");
  document.getElementById("quote-price").innerText = "";
  document.getElementById("real_price").innerText = "";
  document.getElementById("discount_text").innerText = "";
}

// Validate inputs
function validateInputs() {
  var isValid = true;

  // Validate width
  var width = parseFloat(document.getElementById("width").value);
  if (isNaN(width) || width < 1) {
    document.getElementById("width-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("width-error").style.display = "none";
  }

  // Validate length
  var length = parseFloat(document.getElementById("length").value);
  if (isNaN(length) || length < 1) {
    document.getElementById("length-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("length-error").style.display = "none";
  }

  // Validate quantity
  var qty = parseFloat(document.getElementById("quote_qty").value);
  if (isNaN(qty) || qty < 1) {
    document.getElementById("quote_qty-error").style.display = "block";
    isValid = false;
  } else {
    document.getElementById("quote_qty-error").style.display = "none";
  }

  return isValid;
}

// Calculate price for custom size
function calculatePrice() {
  if (categorySquareFeetPrice <= 0) {
    alert("Pricing information not available. Please contact us for a quote.");
    return;
  }

  if (!validateInputs()) {
    return;
  }

  var widthInches = parseFloat(document.getElementById("width").value);
  var lengthInches = parseFloat(document.getElementById("length").value);
  var qty = parseFloat(document.getElementById("quote_qty").value);
  var deliveryTime = document.getElementById("deliveryTime").value;

  // Calculate square feet (convert from square inches)
  var squareFeet = (widthInches * lengthInches) / 144;
  var priceTotal = squareFeet * categorySquareFeetPrice;
  var priceWithQty = priceTotal * qty;

  // Apply discount if selected
  if (deliveryTime === "2") {
    var discountValue = (priceWithQty / 100) * 20;
    var discountedPrice = priceWithQty - discountValue;

    document.getElementById("real_price").innerText =
      "$" + priceWithQty.toFixed(2);
    document.getElementById("quote-price").innerText =
      "$" + discountedPrice.toFixed(2);
    document.getElementById("discount_text").innerText = "(20% off)";
    document.getElementById("real_price").style.display = "inline";
    document.getElementById("discount_text").style.display = "inline";
  } else {
    document.getElementById("quote-price").innerText =
      "$" + priceWithQty.toFixed(2);
    document.getElementById("real_price").style.display = "none";
    document.getElementById("discount_text").style.display = "none";
  }

  // Show the total section
  document.querySelector(".total").classList.remove("hidden");
}

// Add custom size to cart
function addQuoteToCart() {
  if (!validateInputs()) {
    return;
  }

  const formData = new FormData(document.getElementById("custom-size-form"));
  const widthValue = formData.get("width");
  const lengthValue = formData.get("length");
  const qty = formData.get("quote_qty");
  const deliveryTime = formData.get("deliveryTime");
  const shape = formData.get("shape");

  // Calculate price to store in properties
  const squareFeet = (parseFloat(widthValue) * parseFloat(lengthValue)) / 144;
  const squarePrice = squareFeet * parseFloat(categorySquareFeetPrice);
  const finalPrice = deliveryTime === "2" ? squarePrice * 0.8 : squarePrice;
  let totalPrice = finalPrice * parseFloat(qty);

  let customQuantity = totalPrice / 0.01;
  customQuantity = Math.round(customQuantity);

  totalPrice = totalPrice / qty;

  const itemData = {
    items: [
      {
        id: custom_rug_id,
        quantity: qty,
        properties: {
          "Rug name": document.querySelector(".product-info .product-title")
            .textContent,
          Width: `${widthValue} inches`,
          Length: `${lengthValue} inches`,
          Shape: shape,
          "Delivery Time":
            deliveryTime === "2" ? "12-16 weeks (20% discount)" : "4-6 weeks",
          Price: "$" + parseFloat(totalPrice).toFixed(2),
        },
      },
    ],
  };

  fetch("https://magento360.com/app_development/api/update-product.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(itemData),
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error("HTTP error! status: " + response.status);
      }
      return response.json();
    })
    .then(function (data) {
      console.log("Response:", data);
    })
    .catch(function (error) {
      console.error("Error:", error);
    });

  // fetch("/cart/add.js", {
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json",
  //     Accept: "application/json",
  //   },
  //   body: JSON.stringify({
  //     items: [
  //       {
  //         id: 50787554001215,
  //         quantity: customQuantity,
  //       },
  //     ],
  //   }),
  // })
  //   .then((response) => response.json())
  //   .then((data) => {
  //     console.log("Product added:", data);
  //     // Optional: update cart drawer or redirect
  //   })
  //   .catch((error) => {
  //     console.error("Error adding product:", error);
  //   });

  // Add to cart
  setTimeout(function () {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(itemData),
    })
      .then((response) => response.json())
      .then((data) => {
        // Update cart count and redirect
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            // Update all cart count elements on page
            document.querySelectorAll(".cart-count").forEach((el) => {
              el.textContent = cart.item_count;
            });
            // this.dispatchEvent(new CustomEvent('on:cart:add', {
            //   bubbles: true,
            //   detail: {
            //     cart: cart,
            //     variantId: data.variant_id
            //   }
            // }));
            window.location.href = "/cart";
          });
      })
      .catch((error) => {
        console.error("Error:", error);
        document.querySelector(".special-size-error").textContent =
          "Error adding to cart. Please try again.";
      });
  }, 2000);
}

function incrementQuantity(inputId) {
  const qtyInput = document.getElementById(inputId);
  qtyInput.value = parseInt(qtyInput.value) + 1;
  validateQuantity(inputId);
  if (inputId === "size_qty") updateSizePrice();
  else resetForm();
}

function decrementQuantity(inputId) {
  const qtyInput = document.getElementById(inputId);
  if (parseInt(qtyInput.value) > 1) {
    qtyInput.value = parseInt(qtyInput.value) - 1;
    validateQuantity(inputId);
    if (inputId === "size_qty") updateSizePrice();
    else resetForm();
  }
}

function validateQuantity(inputId) {
  const qtyInput = document.getElementById(inputId);
  const errorEl = document.getElementById(`${inputId}-error`);

  if (parseInt(qtyInput.value) < 1) {
    if (errorEl) errorEl.style.display = "block";
    qtyInput.value = 1;
  } else {
    if (errorEl) errorEl.style.display = "none";
  }
}

// Price formatting function
function formatPrice(price, format) {
  const precision = format.requiredPrecision || 2;
  const formatted = parseFloat(price).toFixed(precision);
  return format.pattern.replace("%s", formatted);
}

function updateSizePrice() {
  const deliveryTime = document.getElementById("size_deliveryTime").value;
  const qty = parseInt(document.getElementById("size_qty").value) || 1;

  const specialPriceEl = document.querySelector(
    ".special-size-price .special-price"
  );
  const oldPriceEl = document.querySelector(".special-size-price .old-price");
  const discountEl = document.querySelector(".special-size-price .discount");

  // Get base prices (per unit)
  const baseUnitPrice = parseFloat(
    specialPriceEl.getAttribute("data-base-price") ||
      specialPriceEl.getAttribute("data-price")
  );

  // Calculate current total
  const currentTotal = baseUnitPrice * qty;
  let specialPrice = currentTotal;

  // Apply delivery discount if selected
  if (deliveryTime.includes("20% discount")) {
    specialPrice = currentTotal * 0.8;
    discountEl.textContent = "Save 20%";
    oldPriceEl.textContent = formatPrice(
      currentTotal,
      window.productPriceData.priceFormat
    );
    oldPriceEl.setAttribute("data-price", currentTotal.toFixed(2));
  } else {
    const originalUnitPrice = parseFloat(
      oldPriceEl.getAttribute("data-base-price") ||
        oldPriceEl.getAttribute("data-price") ||
        0
    );

    if (originalUnitPrice && originalUnitPrice > baseUnitPrice) {
      const originalPrice = originalUnitPrice * qty;
      const discountPercent = Math.round(
        ((originalPrice - currentTotal) * 100) / originalPrice
      );

      oldPriceEl.textContent = formatPrice(
        originalPrice,
        window.productPriceData.priceFormat
      );
      discountEl.textContent = `Save ${discountPercent}%`;
      oldPriceEl.setAttribute("data-price", originalPrice.toFixed(2));
    } else {
      oldPriceEl.textContent = "";
      oldPriceEl.removeAttribute("data-price");
      discountEl.textContent = "";
    }
  }

  // Update displayed prices
  specialPriceEl.textContent = formatPrice(
    specialPrice,
    window.productPriceData.priceFormat
  );
  specialPriceEl.setAttribute("data-price", specialPrice.toFixed(2));
}

document
  .getElementById("size_deliveryTime")
  ?.addEventListener("change", updateSizePrice);
document
  .getElementById("size_qty")
  ?.addEventListener("change", updateSizePrice);

// Size selection
document.querySelectorAll('[data-role="size-price"]').forEach((element) => {
  element.addEventListener("click", function () {
    const pid = this.getAttribute("data-pid");
    const baseFinalPrice = this.getAttribute("data-base-final-price");
    const basePrice = this.getAttribute("data-base-price");
    const discount = this.getAttribute("data-discount");

    // Update active state
    document.querySelectorAll('[data-role="size-price"]').forEach((el) => {
      el.classList.remove("active");
    });
    this.classList.add("active");

    // Update product ID
    document
      .getElementById("special-size-addtocart")
      ?.setAttribute("data-pid", pid);

    custom_rug_id = pid;

    // Get elements
    const specialPriceEl = document.querySelector(
      ".special-size-price .special-price"
    );
    const oldPriceEl = document.querySelector(".special-size-price .old-price");
    const discountEl = document.querySelector(".special-size-price .discount");

    // Update prices
    specialPriceEl.textContent = formatPrice(
      baseFinalPrice,
      window.productPriceData.priceFormat
    );
    specialPriceEl.setAttribute("data-price", baseFinalPrice);
    specialPriceEl.setAttribute("data-base-price", baseFinalPrice);

    if (discount) {
      oldPriceEl.textContent = formatPrice(
        basePrice,
        window.productPriceData.priceFormat
      );
      oldPriceEl.setAttribute("data-price", basePrice);
      oldPriceEl.setAttribute("data-base-price", basePrice);
      discountEl.textContent = `Save ${discount}%`;
    } else {
      oldPriceEl.textContent = "";
      discountEl.textContent = "";
      oldPriceEl.removeAttribute("data-price");
      oldPriceEl.removeAttribute("data-base-price");
    }

    // Reset quantity and update
    document.getElementById("size_qty").value = 1;
    updateSizePrice();
  });
});

// Add special size to cart
function addSpecialSizeToCart() {
  const qty = document.getElementById("size_qty").value;
  const shape = document.getElementById("size_shape").value;
  const deliveryTime = document.getElementById("size_deliveryTime").value;
  let price = document
    .querySelector(".special-price")
    .getAttribute("data-price");
  const selectedSize = document.querySelector(
    '[data-role="size-price"].active'
  );
  var special_size_value = selectedSize.getAttribute("data-value");
  var special_size_id = selectedSize.getAttribute("data-pid");

  let customQuantity = price / 0.01;
  customQuantity = Math.round(customQuantity);

  price = price / qty;

  let productId = custom_rug_id;

  if(deliveryTime != '4-6 weeks'){
    productId = 50798778384703;
  }

  const itemData = {
    items: [
      {
        id: productId,
        quantity: qty,
        properties: {
          "Rug name": document.querySelector(".product-info .product-title")
            .textContent,
          "Special Size": special_size_value,
          Shape: shape,
          "Delivery Time": deliveryTime,
          Price: "$" + parseFloat(price).toFixed(2),
        },
      },
    ],
  };

   if(deliveryTime != '4-6 weeks'){

   fetch("https://magento360.com/app_development/api/update-product.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(itemData),
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error("HTTP error! status: " + response.status);
      }
      return response.json();
    })
    .then(function (data) {
      console.log("Response:", data);
    })
    .catch(function (error) {
      console.error("Error:", error);
    });

   }
  setTimeout(function () {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(itemData),
    })
      .then((response) => response.json())
      .then((data) => {
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            // this.dispatchEvent(new CustomEvent('on:cart:add', {
            //   bubbles: true,
            //   detail: {
            //     cart: cart,
            //     variantId: data.variant_id
            //   }
            // }));
           window.location.href = "/cart";
          });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, 2000);
}
document.querySelector('[data-role="size-price"]')?.click();
